/* unplugin-vue-components disabled */import script from "./bottonBar.vue?vue&type=script&setup=true&lang=js"
export * from "./bottonBar.vue?vue&type=script&setup=true&lang=js"

import "./bottonBar.vue?vue&type=style&index=0&id=4491b07e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4491b07e"]])

export default __exports__